import DOMPurify from 'dompurify';

export const sanitizeHtml = (
  html: string,
  config: DOMPurify.Config | undefined,
) => {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.nodeName === 'IMG' && !node.hasAttribute('alt')) {
      node.setAttribute('alt', '');
    }
  });

  const sanitized = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target', 'alt'],
    FORBID_TAGS: ['form'],
    ...(config ?? {}),
    RETURN_DOM_FRAGMENT: false,
    RETURN_DOM: false,
  });

  DOMPurify.removeHook('afterSanitizeAttributes');

  return sanitized;
};
